import React from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useEffect, useState, createContext, useRef } from "react";
import request from "../../../Helpers/API";
import { GetKey } from "../../../Helpers/GetKey";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import Swal from "sweetalert2";
import FiltroDashboard from "../../Finanzas/Dashboard/FiltroDashboard";
import { useBox } from "../../Finanzas/Helper/useBox";
import { ChartPolizasDuplicadas } from "./ChartPolizasDuplicadas";
import { ChartConciliacionIngresos } from "./ChartConciliacionIngresos";
import FiltroFiscal from "../FiltroFiscal";
import { generarFacturaPDF } from "../../../Helpers/generarFacturaPDF";

export const DashboardFiscalMain = () => {
  const history = useHistory();
  const [data, setData] = useState(null);
  const [chartsLoaded, setChartsLoaded] = useState(false);
  const [boxstate, setBoxState] = useBox();
  const [titulo, setTitulo] = useState("DASHBOARD FISCAL");
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const datapass = [
    { nombre: "Póliza A", total: 12 },
    { nombre: "Póliza B", total: 30 },
    { nombre: "Póliza C", total: 18 },
  ];

  const handleClickIncidencias = () => {
    history.push("/Fiscal/ListadoInvoice");
  };

  const handleClickConciliacion = () => {
    history.push({
      pathname: "/Fiscal/ConciliacionIngresos",
      state: { reporte: "A" }
    });
  };

  const handleClickConciliacionInvoice = () => {
    history.push({
      pathname: "/Fiscal/ConciliacionIngresos",
      state: { reporte: "I" }
    });
  };

  useEffect(() => {
    onExecute();
  }, []);

  const onExecute = () => {
    setData(datapass);
    setChartsLoaded(true);
    return;
  };

  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"dashboard-fiscal"}
    >
      <LoaderScreen loader={loader} />
      <div className="dashboard-fiscal-actions">
        <div className="dashboard-fiscal-actions-filtro">
          <FiltroFiscal
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
          />
        </div>
      </div>
      {chartsLoaded && data && (
        <>
          <div className="dashboard-fiscal-container scroll-4">
            <div className="dashboard-fiscal-container-boxes">
              <div
                className="dashboard-fiscal-container-box-2-row"
                onClick={handleClickIncidencias}
              >
                <div className="dashboard-fiscal-container-box-titulo">
                  Alertas e Incidencias
                </div>
                <div className="dashboard-fiscal-container-box-info">
                  <ChartPolizasDuplicadas data={data} />
                </div>
              </div>
              <div
                className="dashboard-fiscal-container-box-2-row"
                onClick={handleClickConciliacion}
              >
                <div className="dashboard-fiscal-container-box-titulo">
                  Conciliacion de Ingresos Analitica
                </div>
                <div className="dashboard-fiscal-container-box-info">
                  <ChartConciliacionIngresos data={data} />
                </div>
              </div>
              <div
                className="dashboard-fiscal-container-box-2-row"
                onClick={handleClickConciliacionInvoice}
              >
                <div className="dashboard-fiscal-container-box-titulo">
                  Conciliacion de Ingresos Invoice
                </div>
                <div className="dashboard-fiscal-container-box-info">
                  <ChartConciliacionIngresos data={data} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </PlantillaScreen>
  );
};
export const onDownLoadPdfSAT = (document, loader, setLoader) => {
  setLoader({ ...loader, mostrar: true });
  request
    .get(`ListadoInvoiceMoviemientos/Obtenerxml?documento=${document}`)
    .then((result) => {
      generarFacturaPDF(result.xmlsat, result.usuario, result.documento);
      setLoader({ ...loader, mostrar: false });
    })
    .catch((error) => {
      setLoader({ ...loader, mostrar: false });
      Swal.fire("FISCAL", JSON.stringify(error), "error");
    });
};
